/*eslint-disable*/
import './reviewBookingOthers.css';
import { useContext, useEffect, useRef, useState } from 'react';
import ReviewBookInfo from './reviewBookSection/reviewBookInfo/ReviewBookInfo';
import ReviewBookSumm from './reviewBookSection/reviewBookSumm/ReviewBookSumm';
import { BookingDataContext } from '../../context/BookingDataContext';
import errorHandle from '../../utils/errorHandle';
import { toast } from 'react-toastify';
import { bookingStatus, createOrderId, tripAvaFun, tripReserveFun, tripReserveGuestFun } from '../../api/bookingAPI';
import ReactLoading from 'react-loading';
import { Navigate, useParams } from 'react-router-dom';
import emailValid from '../../utils/emailValid';
import phoneValid from '../../utils/phoneValid';
import TitleBar from '../../components/titleBar/titleBar';
import Payment from '../../components/payment/payment';
import { claimCashOrCoins, userInfoFun } from '../../api/userAPI';
import moment from 'moment';
import { UserAuthContext } from '../../context/UserAuthContext';
import { getTaxAmount, getTransationCharges } from '../../utils/getAmountWithTransaction';
import { useNavigate } from 'react-router-dom';
import CustomHeader from '../../webPageSections/header/orgHeader/CustomHeader';
import { useTempOrg } from '../../context/TempOrgContext';

export default function ReviewBookingOthers() {
    const { bookingData, setBookingData } = useContext(BookingDataContext);
    const bookedData = JSON.parse(localStorage.getItem('bookedData') || null);
    const { type } = useParams();
    const { tempOrg } = useTempOrg();
    const [finalData, setFinalData] = useState({});
    const { isAuthenticated } = useContext(UserAuthContext);
    const peopleCount = parseInt(bookingData?.people) || 0;
    const [paymentType, setPaymentType] = useState(bookingData?.paymentType || 'UPI');
    const [changeLoading, setChangeLoading] = useState(false);
    const [offerType, setOfferType] = useState('');
    const [cashToRedeem, setCashToRedeem] = useState(0);
    const [userDetails, setUserDetails] = useState(() =>
        Array.from({ length: peopleCount }, () => ({
            name: '',
            age: 0,
            sex: '',
            countryCode: '+91',
            phoneNumber: '',
            emailId: ''
        }))
    );

    const [navHome, setNavHome] = useState(false);
    const [navDetails, setNavDetails] = useState(false);
    const [selectedType, setSelectedType] = useState(bookingData.selectedType ?? ''); // "cash" or "coins"
    const [amount, setAmount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [guest, setGuest] = useState(false);
    const [paymentData, setPaymentData] = useState({
        reserveId: '',
        abandonId: '',
        orderId: ''
    });
    const [offerData, setOfferData] = useState({});
    const [loggedInUser, setLoggedInUser] = useState({});
    const [options, setOptions] = useState({
        amount: '',
        name: '',
        description: '',
        order_id: '',
        prefill: {
            name: '',
            email: '',
            contact: ''
        }
    });
    const paymentRef = useRef();
    const navigate = useNavigate();

    // function checkData() {
    //     if (userDetails.length === +bookingData.people) {
    //         return userDetails.every((obj) => Object.values(obj).every((value) => value !== ''));
    //     } else {
    //         return false;
    //     }
    // }

    useEffect(() => {
        const fetchUserData = async () => {
            if (!isAuthenticated) return;
            const res = await userInfoFun();
            setLoggedInUser(res.data);
        };
        fetchUserData();
    }, [isAuthenticated]);

    useEffect(() => {
        const userDataa = JSON.parse(localStorage.getItem('userData1'));
        const paymentMethod = localStorage.getItem('paymentType');
        if (userDataa && paymentData) {
            setUserDetails(userDataa);
            setPaymentType(paymentMethod);
        }
        localStorage.setItem('paymentTypeChange', 'true');
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        async function checkPaymentStatus() {
            if (!bookedData?.bookingId) return;

            try {
                const res = await bookingStatus(type, bookedData.bookingId);

                const paymentState = res?.data?.paymentInfo?.status;

                if (paymentState === 'Paid') {
                    localStorage.setItem('backendBookingData', JSON.stringify(res.data));
                    navigate('/booking-confirmation');
                } else if (paymentState === 'Failed') {
                    console.log('Payment not yet done');
                }
            } catch (error) {
                console.error('Polling failed:', error);
            }
        }

        // run first time
        checkPaymentStatus();
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (paymentData.orderId) {
            paymentRef.current?.initiatePayment();
            window.paymentTimeout = setTimeout(() => {
                const currentPath = window.location.pathname;

                if (currentPath !== '/booking-confirmation') {
                    navigate('/payment-verification', {
                        state: {
                            type: type
                        }
                    });
                }
            }, 45000);
        }
        //eslint-disable-next-line
    }, [paymentData]);

    useEffect(() => {
        setOptions({
            amount: bookingData.totalAmo * 100,
            name: bookingData.title,
            description: bookingData.title,
            order_id: '',
            prefill: {
                name: loggedInUser?.name || userDetails[0]?.name,
                email: loggedInUser?.emailId || userDetails[0]?.emailId,
                contact: loggedInUser?.phoneNumber || userDetails[0]?.phoneNumber
            }
        });
        //eslint-disable-next-line
    }, [bookingData, loggedInUser, userDetails]);

    const handleApplyOffer = (offerAmo) => {
        const totalAmo = Math.round(bookingData.totalAmo - offerAmo);

        setBookingData((prev) => ({ ...prev, totalAmo }));
    };

    const handleRemoveOffer = () => {
        // baseAmountRef.current += Math.round(cashToRedeem > 0 ? cashToRedeem : offerData.offerPrice);

        const totalAmo = Math.round(bookingData.totalAmo + bookingData.offerAmo);

        setBookingData((prev) => ({
            ...prev,
            totalAmo,
            offerCode: '',
            offerType: null,
            selectedType: null,
            offerData: {},
            offerApplied: false,
            offerAmo: 0
        }));

        setCashToRedeem(0);
        setAmount(0);
        setSelectedType('');
        toast.success('Offer removed successfully');
    };

    const handleCashOrCoins = async (e) => {
        const payload = {
            claim: selectedType,
            [selectedType]: Number(amount)
        };

        try {
            const { data } = await claimCashOrCoins(payload);
            setOfferType('cashOrcoin');
            setCashToRedeem(data.userCash ?? data.amount);
            setBookingData((prevState) => ({
                ...prevState,
                offerAmo: data.userCash ?? data.amount,
                offerType: 'cashOrcoin',
                selectedType: selectedType
            }));
            handleApplyOffer(data.userCash ?? data.amount);
        } catch (error) {
            console.error(error);
            toast.warning(error?.response?.data?.message);
        }
    };

    const formatParentData = async (res, orderInfo) => {
        if (res.data.orderId) {
            try {
                localStorage.setItem('bookedData', JSON.stringify(res.data));
                localStorage.setItem('bookingData1', JSON.stringify({ ...bookingData, ...finalData }));
                localStorage.setItem('userData1', JSON.stringify(userDetails));
                localStorage.setItem('paymentType', paymentType);
                localStorage.setItem('tripImage', bookingData.tripImage);
                localStorage.setItem('packId', bookingData.packId);
                localStorage.setItem('packDateId', bookingData.packDateId);
                localStorage.setItem('bookingType', type);
                const payment = {
                    orderId: res.data.orderId,
                    bookingId: res.data.bookingId
                };

                if (res.data.reserveId) {
                    payment.reserveId = res.data.reserveId;
                }

                setPaymentData(payment);
            } catch (error) {
                console.log(error);
            }
        }
    };

    async function reviewConfirm() {
        for (let i = 0; i < userDetails.length; i++) {
            const item = userDetails[i];
            const participantNum = `Participant ${i + 1}`;

            if (!item.name || item.name.trim() === '') {
                toast.error(`${participantNum}: Name is required`);
                return;
            }
            if (item.name.length > 30) {
                toast.error(`${participantNum}: Name should be less than 30 characters`);
                return;
            }
            if (!item.age || isNaN(item.age)) {
                toast.error(`${participantNum}: Age is required`);
                return;
            }
            if (item.age < 5 || item.age > 65) {
                toast.error(`${participantNum}: Age should be between 5 and 65`);
                return;
            }
            if (!item.sex || item.sex === 'Select') {
                toast.error(`${participantNum}: Gender selection is required`);
                return;
            }
            if (i === 0 && (!emailValid(item.emailId) || item.emailId === '')) {
                toast.error(`${participantNum}: email is invalid`);
                return;
            }
            if (!phoneValid(item.phoneNumber) || item.phoneNumber === '') {
                toast.error(`${participantNum}: phone number is invalid`);
                return;
            }
        }

        setLoading(true);

        try {
            // Format user details
            const formattedUserDetails = userDetails.map(
                ({ name, age, sex, phoneNumber, countryCode, emailId }, index) => ({
                    name,
                    age,
                    sex,
                    phoneNumber,
                    countryCode,
                    ...(index === 0 ? { emailId } : {}),
                    ...(guest ? {} : { userId: localStorage.getItem('userId') })
                })
            );
            const paid =
                bookingData.amountPaid.total -
                (bookingData.offerAmo ? bookingData.offerAmo : 0) +
                (paymentType === 'UPI' ? 0 : bookingData.convinienceFee);
            const paidReserved =
                (type === 'act' ? bookingData.reserveTotal : bookingData?.priceDetails?.reserveTotal) +
                (paymentType === 'UPI'
                    ? 0
                    : type === 'act'
                      ? bookingData.convinienceFee
                      : getTransationCharges(bookingData?.priceDetails?.reserveTotal));
            const offerTypeApplied =
                cashToRedeem > 0 ? (selectedType === 'coins' ? 'coins_used' : 'cash_used') : 'percentage';
            const coinsOrCashUsed =
                cashToRedeem > 0 && (selectedType === 'coins' ? { coinsUsed: amount } : { cashUsed: amount });
            const baseData = {
                startDate: bookingData.date,
                endDate: bookingData.date,
                organizerId: bookingData.organizerId,
                offerApplied: offerData?._id || null,
                amountPaid: {
                    ...bookingData.amountPaid,
                    paid: bookingData.amountPaid.isReserved ? paidReserved : paid,
                    offerAmount: cashToRedeem > 0 ? cashToRedeem : bookingData.offerAmo ? bookingData.offerAmo : 0,
                    installments: false
                        ? [
                              {
                                  name: 'Installment 1',
                                  total: installmentPrice,
                                  date: new Date().toISOString(),
                                  status: 'Paid'
                              }
                          ]
                        : []
                },
                type,
                meetupLocation: bookingData.meetupLocation,
                userDetails: formattedUserDetails
            };

            if (type === 'gu') {
                baseData.totalSeats = Number(bookingData.people);
                baseData.seatsCount = Number(bookingData.people);
                baseData.guTourId = bookingData.packId;
                baseData.language = bookingData.language;
                baseData.timeSlots = bookingData.timeSlots;
                baseData.guDatesId = bookingData.guDatesId;
                baseData.slotId = bookingData.slotId;
                baseData.place = bookingData.place;
            }
            if (type === 'act') {
                baseData.totalSeats = bookingData.totalSeats.map((item) => ({
                    name: item.name,
                    prPerPr: Math.floor(item.total / item.count),
                    count: item.count,
                    qty: item.qty
                }));
                baseData.actId = bookingData.packId;
                baseData.actDatesId = bookingData.actDatesId;
                baseData.timeSlots = bookingData.timeSlots;
                baseData.slotId = bookingData.slotId;
            }
            if (offerData) {
                baseData.offerType = {
                    name: offerData?.name || '',
                    code: offerData?.code || '',
                    type: offerTypeApplied || 'fixed'
                };
            }
            if (!offerData?.id && selectedType !== '') {
                baseData.offerType = {
                    type: offerTypeApplied,
                    ...coinsOrCashUsed
                };
            }
            console.log(baseData);
            setFinalData(baseData);
            await handleReservation(baseData, guest);
        } catch (error) {
            errorHandle(error);
        } finally {
            setLoading(false);
        }
    }

    async function handleReservation(data, isGuest) {
        try {
            const response = isGuest ? await tripReserveGuestFun(data, type) : await tripReserveFun(data, type);
            formatParentData(response);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(
        function () {
            if (Object.keys(bookingData).length === 0) {
                return setNavHome(true);
            }
        },
        [bookingData]
    );

    if (navHome) {
        return <Navigate to='/' />;
    }

    if (navDetails) {
        return <Navigate to={`/${bookingData.type}/details/${bookingData.packId}`} />;
    }

    if (!bookingData || Object.keys(bookingData).length === 0) {
        navigate('/');
    }

    return (
        <div>
            {loading &&
                (!changeLoading ? (
                    <div className='loadingBackground'>
                        <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                    </div>
                ) : (
                    <div className='loadingBackgroundPayment'>
                        <ReactLoading type='spin' color='#006aff' className='loadingSpinPayment' />
                        <p className='loadingText'>Please wait while we verify your payment…</p>
                    </div>
                ))}
            <div style={{ marginTop: tempOrg?.id ? '60px' : '' }}>
                <TitleBar title='Review Booking Details' />
            </div>
            <div className='bookingReviewDetails'>
                <ReviewBookInfo
                    userDetails={userDetails}
                    bookingData={bookingData}
                    setUserDetails={setUserDetails}
                    guest={guest}
                    setGuest={setGuest}
                />
                <div className='bookingReviewPriceDiv'>
                    <ReviewBookSumm
                        setBookingData={setBookingData}
                        bookingData={bookingData}
                        reviewConfirm={reviewConfirm}
                        loggedInUser={loggedInUser}
                        setNavDetails={setNavDetails}
                        paymentType={paymentType}
                        setOfferType={setOfferType}
                        selectedType={selectedType}
                        setSelectedType={setSelectedType}
                        amount={amount}
                        setAmount={setAmount}
                        cashToRedeem={cashToRedeem}
                        setCashToRedeem={setCashToRedeem}
                        handleCashOrCoins={handleCashOrCoins}
                        setPaymentType={setPaymentType}
                        isAuthenticated={isAuthenticated}
                        handleApplyOffer={handleApplyOffer}
                        handleRemoveOffer={handleRemoveOffer}
                    />
                </div>
                <Payment
                    ref={paymentRef}
                    paymentType={paymentType}
                    options={options}
                    bookingData={bookingData}
                    userDetails={userDetails}
                    paymentData={paymentData}
                    tripImage={bookingData.tripImage}
                    guest={guest}
                    setLoading={setLoading}
                    setChangeLoading={setChangeLoading}
                    packData={{ packId: bookingData.packId, packDateId: bookingData.packDateId }}
                    finalData={finalData}
                    type={type}
                />
            </div>
        </div>
    );
}
